const sanitizeInput = (str) => {
    const temp = document.createElement('div');
    temp.textContent = str;
    return temp.innerHTML;
};
export function getQueryParam(paramName, keepCase = false) {
    const queryStringRaw = window.location.search;
    const queryString = keepCase ? queryStringRaw : queryStringRaw?.toLowerCase();
    const params = new URLSearchParams(queryString);
    const rawValue = params.get(paramName?.toLowerCase()) || '';
    return sanitizeInput(rawValue);
}
//# sourceMappingURL=getQueryParam.js.map